export default function () {

  $(window).load(function () {

    var height = $('#siteHeader').height();
    $("#mobileMenu").css({ top: height });

	});
}



// WEBPACK FOOTER //
// ./scripts/components/SetupHeaderHeight.js